const generateNumberFromString = (str: string, min: number, max: number) => {
  // Use a more robust hash function with better avalanche effect
  let hash = 0x811c9dc5; // FNV-1a offset basis (32-bit)

  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i); // XOR with character code
    hash = Math.imul(hash, 0x01000193); // Multiply by FNV prime (32-bit)
  }

  // Additional mixing to improve distribution
  hash ^= hash >>> 16;
  hash = Math.imul(hash, 0x85ebca6b);

  const range = max - min + 1;
  const num = (Math.abs(hash) % range) + min;
  return num;
};

export default generateNumberFromString;
